export const CORE_TYPE_PARTICLE = 'Particle';
export const CORE_TYPE_POOL = 'Pool';
export const CORE_TYPE_SYSTEM = 'System';
